"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateAgeType = exports.calculateAgeTypeOnFlight = exports.getAgeType = exports.limitAges = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTimeFormat_1 = require("./dateTimeFormat");
exports.limitAges = {
    infant: 2,
    child: 12,
};
const getAgeType = (birthday, flightDate) => {
    const adultDate = birthday.clone().add(exports.limitAges.child, 'year');
    const isAdult = flightDate.isSameOrAfter(adultDate, 'day');
    if (isAdult)
        return 'adult';
    const childDate = birthday.clone().add(exports.limitAges.infant, 'year');
    const isChild = flightDate.isSameOrAfter(childDate, 'day');
    if (isChild)
        return 'child';
    return 'infant';
};
exports.getAgeType = getAgeType;
const calculateAgeTypeOnFlight = (birthday, flightDate, birthdayFormat = dateTimeFormat_1.DATE_OUTPUT_FORMAT) => {
    if (!birthday || !flightDate)
        return 'adult';
    const birthdayMoment = moment_1.default.parseZone(birthday, birthdayFormat);
    const flightDateMoment = moment_1.default.parseZone(flightDate);
    if (!birthdayMoment.isValid())
        return 'adult';
    return (0, exports.getAgeType)(birthdayMoment, flightDateMoment);
};
exports.calculateAgeTypeOnFlight = calculateAgeTypeOnFlight;
const translateAgeType = (ageType) => {
    const dict = {
        adult: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/utils/ageType:adult', defaultMessage: 'Adult' })),
        child: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/utils/ageType:child', defaultMessage: 'Child' })),
        infant: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/utils/ageType:infant', defaultMessage: 'Infant' })),
    };
    if (!ageType)
        return undefined;
    return dict[ageType];
};
exports.translateAgeType = translateAgeType;
//# sourceMappingURL=ageType.js.map